const store = require('store')

export default () => !!store.get('loggedIn')
